import ErrorBoundary from './components/common/ErrorBoundary';
import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { register as registerServiceWorker } from './registerServiceWorker';
import { logger } from './utils/logger';

// Create toast container for app update notification
const createUpdateToast = () => {
  const toast = document.createElement('div');
  toast.className = 'app-update-toast';
  toast.innerHTML = `
    <div style="position:fixed; bottom:20px; left:50%; transform:translateX(-50%); background:#fff; border-radius:8px; 
                padding:16px; box-shadow:0 4px 12px rgba(0,0,0,0.15); z-index:9999; display:flex; align-items:center;
                justify-content:space-between; max-width:400px; width:90%;">
      <div style="margin-right:16px;">
        <strong style="display:block; margin-bottom:4px; color:#333;">Update Available</strong>
        <span style="font-size:14px; color:#666;">A new version of the app is available</span>
      </div>
      <button style="background:#dc143c; color:white; border:none; padding:8px 16px; border-radius:4px; 
                     cursor:pointer; font-weight:600;" id="app-update-btn">Update Now</button>
    </div>
  `;
  document.body.appendChild(toast);
  
  document.getElementById('app-update-btn').addEventListener('click', () => {
    logger.log('User triggered app update');
    window.location.reload(true);
    toast.remove();
  });
  
  return toast;
};

// Listen for service worker updates using a custom event name
document.addEventListener('serviceWorkerUpdated', () => {
  logger.log('Received service worker update event');
  const toast = createUpdateToast();
  
  // Auto-remove after 1 minute if not clicked
  setTimeout(() => {
    if (document.body.contains(toast)) {
      toast.remove();
    }
  }, 60000);
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ErrorBoundary>
);

registerServiceWorker();
